import { render, staticRenderFns } from "./material-selector.vue?vue&type=template&id=c6d2d322&scoped=true&"
import script from "./material-selector.vue?vue&type=script&lang=ts&"
export * from "./material-selector.vue?vue&type=script&lang=ts&"
import style0 from "./material-selector.vue?vue&type=style&index=0&id=c6d2d322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d2d322",
  null
  
)

export default component.exports